<template>
  <div class="PC_goodlist">
    <el-dialog :title="$t('other.a3')" :visible.sync="customerDia" :modal="false"   width="30%">
			<div class="owklgg">
				<div class="okgjbkd">
					<div class="appimg">
						<img style="width:100%" src="https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/030e863e1b5042b4bd4ea58cecbc6b17.png" />
					</div>
					<div class="tesxt"><span>{{$t('other.a1724')}}</span></div>
					
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				
				<div>
					<el-button type="primary" @click="customerDia=false">{{$t('other.a5')}} </el-button>
				</div>
			</span>
		</el-dialog>
      <div class="beifenxi">
        <el-dialog :visible.sync="dialogVisible" width="70%"
    >
    <div class="textDesc">{{$t('other.a1725')}}:
      {{$t('other.a1726')}} 
      <a style="color:#fff" href="https://www.weanaly.com/chrome-extension/download-crx">
        <el-button class="el-icon-download" type="primary">{{$t('other.a1727')}}</el-button>
        </a>
        </div>
     <template>
        <el-table
          :data="tableList"
          size='mini'
          border
          height='450'
          :default-sort = "{prop: 'surgeIndex', order: 'descending'}"
          style="width: 100%;height:450px">
          <el-table-column :label="$t('other.a1728')" width="100">
            <template slot-scope="scope">
              <div class="picbox" >
                <img style="width:100%" :title="scope.row.name" :src="getImageUrlCopy(conturyCode,scope.row.image)" >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="surgeIndex" sortable :label="$t('other.a1729')">
            <template slot-scope="scope">
              <span>{{scope.row.surgeIndex}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1730')" sortable>
            <template slot-scope="scope">
              <span>{{scope.row.sold}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1731')" sortable>
            <template slot-scope="scope">
              <span>
                {{
                  '¥' + getMonthTotalSales(
                      scope.row.models,
                      scope.row.currency,
                      scope.row.price_max,
                      scope.row.price_min,
                      scope.row.sold,
                    )
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1732')" sortable>
            <template slot-scope="scope">
              <span>{{getDayNum(scope.row.ctime)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1733')" sortable>
            <template slot-scope="scope">
              <span> ¥ {{getLatestRMBPrice(scope.row.price_min,scope.row.currency)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1734')" sortable>
            <template slot-scope="scope">
              <span>{{getConversionRate(scope.row.sold,scope.row.view_count)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a33')" >
            <template slot-scope="scope">
              <el-button size="mini" type="primary"  @click="toGoodsDetailPage(scope.row.shopid, scope.row.itemid,scope.row.currency)">{{$t('other.a1735')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{$t('other.a5')}}</el-button>
      </span>
    </el-dialog>
      </div>


      <div class="swiperImg">
          
          <img v-show="showPic == 0" style="width:100%" src="@assets/img/banner.jpg" />
          <img v-show="showPic == 1" style="width:100%" src="@assets/img/banner01.jpg" />
          <div class="circleWrapper">
           
            <span :class="{'circle':true, 'active':showPic == 0}" @mouseenter="HovePic(0)" @mouseleave="beginSwiper()"></span>
            <span :class="{'circle':true, 'active':showPic == 1}" @mouseenter="HovePic(1)" @mouseleave="beginSwiper()"></span>

          </div>
          
          <el-button type="warning" class="dowBtn" :class="showPic == 0?'dowBtnTwo':''">
            <a href="https://m.shopsbu.com/download/" target="_blank" style="width:100%;height: 100%;color: #fff;">
              {{$t('other.a1736')}}
            </a>
          </el-button>
      </div>
      <div class="query_listCopy">
        <div class="poo poo_active"><span class="test"  @click="chooseCountry('All')">—— {{$t('other.a1737')}} ——</span></div>
      </div>
      <div class="query_list">
        <div :class="{'poo':true,'poo_active': descActive == 'All'}"><span class="test"  @click="chooseCountry('All')">{{$t('other.a1738')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'TH'}"> <img style="width:20%" src="../../../assets/img/shopee-thailand.png" /> <span class="test" @click="chooseCountry('TH')">{{$t('h5.DSX_index_th')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'MY'}"> <img style="width:20%" src="../../../assets/img/shopee-malaysia.png" /> <span class="test" @click="chooseCountry('MY')">{{$t('h5.DSX_index_my')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'PH'}"> <img style="width:20%" src="../../../assets/img/shopee-philippines.png" /> <span class="test" @click="chooseCountry('PH')">{{$t('h5.DSX_index_ph')}}</span></div>
        <!-- <div :class="{'poo':true,'poo_active': descActive == 'TW'}"> <img style="width:20%" src="../../../assets/img/shopee-taiwan.png" /> <span class="test" @click="chooseCountry('TW')">{{$t('h5.DSX_index_tw')}}</span></div> -->
        <div :class="{'poo':true,'poo_active': descActive == 'ID'}"> <img style="width:20%" src="../../../assets/img/shopee-indonesia.png" /> <span class="test" @click="chooseCountry('ID')">{{$t('h5.DSX_index_id')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'VN'}"> <img style="width:20%" src="../../../assets/img/shopee-vietnam.png" /> <span class="test" @click="chooseCountry('VN')">{{$t('h5.DSX_index_vn')}}</span></div>
      </div>
      <div class="tool">
        <el-select size="medium" v-model="dataParams.categoryName" placeholder="" @change="search()">
                <el-option
                    v-for="item in categoryArr"
                   :key="item"
                   :label="item==''?$t('other.a113'):item"
                   :value="item">
               </el-option>
           </el-select>
           
           <el-input size="medium" style="width:250px;" clearable v-model="dataParams.groupName" :placeholder="$t('other.a1739')"></el-input>
            <el-button style="margin-left:10px" size="medium" type="primary" @click="search()">{{$t('other.a245')}}</el-button>
      </div>
      <div class="wrapper">
          <div class="itemlist" v-for="(item,index) in orderList" :key="index">
              <div class="pic_box" @click="viewDesc(item)">
                  <img style="width:100%" :src="item.image" />
              </div>
              <div class="groupName">
                  {{item.groupName}}
              </div>
              <div class="itemDesc">
                  <span class="knv">{{$t('other.a1713')}}</span><span class="inkn">￥{{item.maxPrice.toFixed(2)}}</span>
              </div>
              <div class="itemDesc">
                  <span class="knv">{{$t('other.a301')}}</span><span class="inkn">{{item.minGrossProfitRate}}~{{item.maxGrossProfitRate}}%</span>
              </div>
              <div class="amount">
                  {{$t('other.a1740')}}：{{item.amount}}
              </div>
              <div class="anylyzia">
                  <div class="icon_item">
                    <img style="width:50%" :src="getImgeUrl(item.country)" />
                  </div>
                  <span @click="remote(item)">{{getCountry(item.country)}}{{$t('other.a1741')}}</span>
              </div>
              <div class="blkgnk">
                <span style="color:green;margin-right:5px;cursor: pointer;" @click="customerDia=true">{{$t('other.a1704')}}</span>
                <span class="btn" @click="distribute(item)">{{$t('other.a1742')}}</span>
              </div>
          </div>
      </div>
      <div class="page">
        <el-pagination
        background
        :current-page.sync="currentPage"
        :page-size="dataParams.offset"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
      </div>
  </div>
</template>

<script>
import api from '../../../api/api'
import distribution from "../../../api/moudles/distribution";
import userStoreItems from "../../../api/moudles/userStoreItems";
import newOrders from '../../../api/moudles/newOrders'
import utils from '../../../utils/utils'
export default {
data(){
return{
    dialogVisible:false,
    conturyCode:null,
    storeItem:null,
    tableList:[],
    TimeOut:null,
    customerDia:false,
    mainImg:{},
    descActive:'All',
    imgUrl:'@assets/img/banner.jpg',
    showPic:0,
    total:0,
    currentPage:1,
    dataParams:{
        categoryIds:[],
        name:null,
        country:null,
        offset:25,
        page:0,
        sortType:0,
        userId:null,
        categoryName:'',
        groupName:''
    },
    orderList:[],
    areaList:[{
        country:'TH',
        label:this.$t('chat.Thailand'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/19eab6fe794e4afb9fa1926be6d69fd1.png'
    },{
        country:'MY',
        label:this.$t('h5.DSX_index_my'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/12ef3ca7a7504a46a94bf6cc9c90afdd.png'
    },{
        country:'PH',
        label:this.$t('h5.DSX_index_ph'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/33c5ac8214fe450fa3a9f79792d5cba7.png'
    },{
        country:'TW',
        label:this.$t('h5.DSX_index_tw'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/f384543fc28841409f5a75346b4e9447.png'
    },{
        country:'ID',
        label:this.$t('chat.Indonesia'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/245a7cf4081347628838b042479e8c3a.png'
    },{
        country:'VN',
        label:this.$t('h5.DSX_index_vn'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/36312c8bb5064d5c9e8d21eda8ea23e6.png'
    }],
    categoryArr:[]
}
},
created(){
    this.setPicSiper()
    this.getDataParams()
    this.getcate()
    console.log(this)
    console.log(this.$t)
    console.log(this.$t('other.a1736'))
    console.log(this.$t('h5.DSXSSSS'))
    console.log(this.$t('h5.DSX_index_th'))

},
methods:{
  search(){
    this.currentPage = 1
    this.dataParams.page = 0
    this.getData()
  },
  getcate(){
        distribution.getcategory().then(res=>{
            if(res.code == 200){
                let arr = ['']
                arr.push(...res.data)
                this.categoryArr = arr
            }
        })
    },
    viewDesc(item){
        console.log(item)
        this.$router.push({
            path:'/mh5/pcdetail',
            query:{
                groupId:item.groupId,
                productId:item.productId
            }
        })
    },

    setPicSiper(){
        this.TimeOut=setInterval(() => {
            this.showPic++
            if(this.showPic > 1){
              this.showPic=0
            }
        }, 4000);
    },

    beginSwiper(){
        this.setPicSiper()
    },

    HovePic(num){
        this.showPic=num
        clearInterval(this.TimeOut)
    },

    distribute(item){
        let userInfo=JSON.parse(localStorage.getItem('userInfo'))
        if(!userInfo){
            this.$confirm(this.$t("other.a1718"), this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a955'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
              this.$router.push({
                path:'/loginPage',
                query:{
                  Distribution:0
                }
              })
            })
            
            return
        }

        console.log(item)
        item.userId=userInfo.userId
        this.$confirm(this.$t("other.a1719"),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a235'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(res => {
            api
            .copyStoreItem(item)
            .then(res => {
            if(res.code === 200) {
                this.$confirm(this.$t("other.a1720"), this.$t("other.a142"), {
                confirmButtonText: this.$t("other.a1721"),
                cancelButtonText: this.$t("other.a1722"),
                type: 'warning'
                }).then(() => {
                  

                    const url="https://erp.shopsbu.com/loginPage"
                    window.open(url, '_blank');
                })
                
              if(res.data.storeItems){
                  res.data.storeItems.forEach(p => {
                    p.synchrony=true
                    this.updataSync(p)
                  })
                }
                
            }else{
                this.$message.warning(res.msg)
            }
            })

        })
        
        
    },
    updataSync(ttp){
      userStoreItems
        .sellerUpdateSynchrony(ttp)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        console.log(res.msg)
        }
        })
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage=parseInt(`${val}`)
        this.dataParams.page= `${val}` == 'undefined' ? 0 : (parseInt(`${val}`) -1) * this.dataParams.offset
        this.getData()
    },

    remote(item){


   

    api
    .getStoreItemByGroupId({groupId:item.groupId})
    .then(res => {
    if(res.code === 200 ){
      console.log('storeitem',res.data)
        this.storeItem=res.data
        this.mainImg.image=item.image
        this.mainImg.name=item.groupName
        this.mainImg.url='https://shopee.ph/~-i.' + this.storeItem.categoryData.shopId + '.' + this.storeItem.categoryData.itemId
        let falg=false
        for(let key in res.data.categoryData){
          console.log(res.data.categoryData[key])
          if(!res.data.categoryData[key]){
            falg=true
          }
        }
        console.log(falg)
        if(falg){
          this.$dialog.alert({
            message: this.$t('other.a1743'),
            title:this.$t("other.a142")
            });

        }

        if(!falg){
          let str='catid='+this.storeItem.categoryData.catId+'&itemid='+this.storeItem.categoryData.itemId+'&shopid='+this.storeItem.categoryData.shopId
          let url=utils.getSimilaryData(this.storeItem.country.toLowerCase(),str)
          this.conturyCode=this.storeItem.country.toLowerCase()

          newOrders
          .proxyHttps({
              type:0,
              url:url,
              headerMap:null,
          })
          .then(res => {
          this.tableList=res.data.sections.similar_product.data.item
          let temp=null
          this.tableList.forEach(e => {
            e.image=utils.getImageUrl(item.country,e.image)
            let saleDays = utils.getMin(30, utils.getDayInterval(e.ctime))
            if (saleDays === 0) {
              temp = 0
            } else {
              let averagePrice = utils.calculateAveragePrice(
                e.models,
                e.currency,
                e.price_max,
                e.price_min,
              )
              temp = parseInt(
                utils.calculateTotalSales(averagePrice, e.sold) / saleDays
              )
            }
            e.surgeIndex = temp
          })
         
           this.dialogVisible=true
           console.log('11',this.tableList)
          })
        }
        
    }else{
      this.$message.warning(res.msg)
    }
    })
   

    },

    getDataParams(){
        if(this.$route.query.invitationCode){
            newOrders
            .getUserInviteeByCode({
                code:this.$route.query.invitationCode
            })
            .then(res => {
                if(res.code == 200) {
                    this.dataParams.userId=res.data.userId
                     this.getData()
                }else{
                    
                }
            })
        }else{
            this.getData()
        }
        
    },

    chooseCountry(id){
      this.currentPage = 1
      this.descActive=id;
      this.dataParams.country=this.descActive =='All' ? null : id
      this.dataParams.page=0
      this.getData(this.dataParams)
    },

    getCountry(code){
      return utils.conutryConversion(code)
    },

    getData(){
        api
        .getPublicStoreItem(this.dataParams)
        .then(res => {
        if(res.code === 200 ){
        console.log('ddpp',res.data)
        let list=res.data.groups
        list.forEach(p => {
          p.minGrossProfitRate=p.minGrossProfitRate < 0 ? 5 :p.minGrossProfitRate
        })
        this.orderList=list
        this.total = res.data.count
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    getImgeUrl(url){
        let ttp= this.areaList.find(item => item.country == url)
        return ttp ? ttp.imgUrl : null
    },
    toGoodsDetailPage(shopid, itemid,country) {
      console.log(country)
      const params={
        PHP:'https://shopee.ph/~-i.',
        THB:'https://shopee.co.th/~-i.',
        MYR:'https://shopee.com.my/~-i.'
      }
      let newUrl =params[country] + shopid + '.' + itemid
      window.open(newUrl)
    },

    // 计算月销售额
    getMonthTotalSales(models, currency, price_max, price_min, sold) {

      let ttp=null
      if (models && models.length) {
        // 计算平均值
        let result = utils.calculateAverage(models, 'price')
        ttp =utils.parseRate(result, currency)
        
      }else{
        ttp= utils.parseRate((price_max + price_min) / 2, currency)
      }
      
      return parseInt(ttp * sold)
    },
     getLatestRMBPrice(price, currency) {
      return utils.parseRate(price, currency).toFixed(1)
    },
    //获取日期间隔
    getDayNum(time) {
        let added = new Date(time * 1000)
        let today = new Date()
        let dayNum = parseInt(Math.abs(today - added) / 1000 / 60 / 60 / 24)
        return dayNum
        
    },
    // 计算最低售价 原始价格
    getLatestOriginPrice(price) {
        return (price / 100000).toFixed(1)
        },
    //转化指数
    getConversionRate(sold, count) {
        if (count === 0) {
        return '0.00%'
        }
        return ((sold / count) * 100).toFixed(2) + '%'
    },

    getImageUrlCopy(contury,image){
      return utils.getImageUrl(contury,image)
    },

}
}

</script>
<style lang='scss' scoped>
@import "~@assets/scss/mixins";
.PC_goodlist{
  .okgjbkd{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 0 10px;
	}

  .appimg{
		width: 145px;
		height: 145px;
		overflow: hidden;
	}

	.owklgg{
		display: flex;
		justify-content: space-around;
	}

  .beifenxi{
    /deep/ .el-dialog__header{
    padding: 20px 20px 10px;
    background: linear-gradient( 
    -180deg
    ,#f53d2d,#f63);
    
    }

    /deep/ .el-dialog__close{
    display: none;
    }

  }



    
    /deep/ .el-icon-download::before{
        padding-right:8px;
    }

    /deep/ .el-dialog__body{
    margin-top: 10px;
    padding:0 10px
    }

    /deep/ .el-dialog__title{
    display: inline-block;
    width: 250px;
    height: 47px;
    background-image: url('../../../assets/img/pic/shopeelogo.png');
    background-repeat: no-repeat;
    background-size: 60%;
    }
    /deep/ .el-icon-close{
    color: #eee;
    font-size: 25px;
    }

    

    .textDesc{
        position: absolute;
        top: 23px;
        width: 100%;
        margin: auto;
        text-align: center;
        color: #fff;
        font-size: 24px;
    }


    .swiperImg{
        overflow: hidden;
        display: flex;
        position: relative;


        .circleWrapper{
            position: absolute;
            bottom: 20px;
            left: 0;
            right: 0;
            margin: 0 auto;
            text-align: center;
            

            .circle{
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #fff;
                margin: 0 10px;
                cursor: pointer;
    
            }

            .active{
                background-color: aqua!important;
            }
        }


        
        
    }



    .wrapper{
        display: flex;
        flex-wrap: wrap;
        padding-left: 20px;
        padding-bottom: 40px;
    }

    .query_listCopy{
        padding: 10px 0 15px 0;
        border-bottom: 1px solid #eee;
        @include flex-center();

        .poo_active{
            background-color: #409eff;
            color: #fff;
        }

        .poo{
            display: flex;
            justify-content: flex-start;
            min-width: 50px;
            min-height: 50px;
            line-height: 30px;
            align-items: center;
            box-shadow: 0 1px 6px 0 #eee;
            border-radius: 8px;
            margin-right: 10px;
            box-sizing: border-box;
            padding: 0 5px;
            cursor: pointer;
            

            .test{
            display: inline-block;
            flex: 1;
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            margin: 0 10px;
            }
        }
    }

    .query_list {
      padding: 10px 0 15px 0;
      margin-bottom: 10px;
     
      @include flex-center();

      .poo_active{
        background-color: #409eff!important;
        color: #fff;
      }

      

      .poo{
        display: flex;
        justify-content: flex-start;
        min-width: 50px;
        min-height: 50px;
        line-height: 30px;
        align-items: center;
        box-shadow: 0 1px 6px 0 #eee;
        border-radius: 8px;
        margin-right: 10px;
        box-sizing: border-box;
        padding: 0 5px;
        background-color: #fff;
        cursor: pointer;
        

        .test{
          display: inline-block;
          flex: 1;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          margin: 0 10px;
        }
      }
    }

    .itemDesc{
        color: red;
        margin: 10px 0;
        box-sizing: border-box;
        padding: 0px 10px;
        font-weight: bold;
    }

    .icon_item{
        
        width: 30px; 
    }

    .blkgnk{
        color: #409eff;
        margin: 10px 0;
        box-sizing: border-box;
        padding: 0px 10px;
        display: flex;
        justify-content: space-between;
        

        .btn{
            background-color: #2aa515;
            border-radius: 3px;
            padding: 4px 5px;
            color: #eee;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
        }
       
    }

    .anylyzia{
        display: flex;
        align-items: center;
        color: #409eff;
        margin: 10px 0;
        box-sizing: border-box;
        padding: 0px 10px;
        cursor: pointer;
        
    }


    .amount{
        display: flex;
        align-items: center;
        margin: 10px 0;
        box-sizing: border-box;
        padding: 0px 10px;
        cursor: pointer;
        
    }

    .itemlist{
        width: 216px;
        // height: 364px;
        border: 1px solid #f2f2f2;
        margin: 0 18px 18px 0;
        position: relative;
        background-color: #fff;
        

        .pic_box{
           width: 214px;
           height: 214px;
           overflow: hidden;
        }

        .knv{
            font-size: 10px;
            color: red;
            box-sizing: border-box;
            padding: 3px;
            border: 1px solid red;
            border-radius:3px ;
            
        }

        .inkn{
            margin-left: 15px;
            
        }

        .groupName{
            margin: 10px 0;
            box-sizing: border-box;
            padding: 0px 10px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            height: 37px;
        }
    }
    
}
.tool {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  padding-right: 20px;
}
.page {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.dowBtn {
  position: absolute;
  top: 180px;
  left: 20px;
  transition: none;
}
.dowBtnTwo {
  top: 320px;
  left: 140px;
}
</style>